import Card from '@material-tailwind/react/Card';
import CardHeader from '@material-tailwind/react/CardHeader';
import CardBody from '@material-tailwind/react/CardBody';
import InputIcon from '@material-tailwind/react/InputIcon';
import DataTable from 'react-data-table-component';
import Button from '@material-tailwind/react/Button';
import { NavLink } from 'react-router-dom/cjs/react-router-dom';

export default function CardTable({ data, pending, handleModal }) {
  const columns = [
    {
      name: 'Admin',
      selector: (row) => row.unam,
      sortable: true,
    },
    {
      name: 'Coin',
      selector: (row) => row.coin,
      sortable: true,
    },
    {
      name: 'Transfer Coin',
      selector: (row) => (
        <Button
          color="lightBlue"
          buttonType="filled"
          size="sm"
          rounded={false}
          block={false}
          iconOnly={false}
          ripple="light"
          onClick={() => {
            handleModal(true, row);
          }}
        >
          🔀
        </Button>
      ),
    },
    {
      name: 'Coin Mutation',
      selector: (row) => (
        <NavLink to={`/money_management/coin_admin/mutation/${row.id}`}>
          <Button
            color="lightBlue"
            buttonType="filled"
            size="sm"
            rounded={false}
            block={false}
            iconOnly={false}
            ripple="light"
          >
            📊
          </Button>
        </NavLink>
      ),
    },
  ];



  return (
    <>
      <Card>
        <CardHeader color="blueGray" contentPosition="left">
          <h2 className="text-white text-2xl">Coin Admin</h2>
        </CardHeader>
        <CardBody>
          <div className="flex justify-end">
            <div style={{ width: 250 }}>
              <InputIcon
                type="text"
                color="lightBlue"
                size="sm"
                outline={true}
                placeholder="Search"
                iconName="search"
              />
            </div>
          </div>
          <DataTable
            columns={columns}
            data={data}
            progressPending={pending}
          />
        </CardBody>
      </Card>
    </>
  );
}
